export default __webpack_public_path__ + "static/teamsplus-3-efe47da44185bc1e36d40f810c32d823.svg";